module.exports = __webpack_public_path__ + "static/assets/cf2dd81a4f884a6edcabe967d62b01d8.svg";